<template>
    <section>
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/danh-sach-lop-hoc">Lớp học</router-link></li>
                    <li><router-link to="/danh-sach-lop-hoc">Lớp học của tôi</router-link></li>
                    <li><router-link to="">{{ this.$route.query.className }}</router-link></li>
                </ul>
            </div>
        </div>
        <div class="container margin-top-20">
            <div class="name-excercise text-center">
                <h3><strong>{{ dataElectronicLecture.name }}</strong></h3>
            </div>
            <div class="row">
                <div class="col-md-3">

                </div>
                <div class="col-md-9">
                    <div class="text-center">
                        <div class="display-flex">
                            <div>
                                <label>Trường học: </label>
                            </div>
                            &nbsp;&nbsp;
                            <div>
                                {{ dataElectronicLecture.nameSchool }}
                            </div>
                        </div>
                        <div class="display-flex">
                            <div>
                                <label>Giáo viên:</label>
                            </div>
                            &nbsp;&nbsp;
                            <div>
                                {{ dataElectronicLecture.nameTeacher }}
                            </div>
                        </div>
                        <div class="display-flex">
                            <div>
                                <label>Khối lớp:</label>
                            </div>
                            &nbsp;&nbsp;
                            <div>
                                {{ dataElectronicLecture.className }}
                            </div>
                            <div>
                                <label class="margin-left-30">Môn học: </label>
                            </div>
                            &nbsp;&nbsp;
                            <div>
                                {{ dataElectronicLecture.subjectName }}
                            </div>
                        </div>
                        <div class="display-flex">
                            <div>
                                <label>Loại đề:</label>
                            </div>
                            &nbsp;&nbsp;
                            <div>
                                {{ dataElectronicLecture.typeExcercise == 1 ? 'Bài kiểm tra' : 'Bài tập' }}
                            </div>
                        </div>
                        <div class="display-flex">
                            <div>
                                <label>Mô tả:</label>
                            </div>
                            &nbsp;&nbsp;
                            <div>
                                {{ dataElectronicLecture.description }}
                            </div>
                        </div>

                        <div v-if="dataElectronicLecture.typeExcercise == 1" class="display-flex align-items-baseline">
                            <div>
                                <label>Thời gian:</label>
                            </div>
                            &nbsp;&nbsp;
                            <div>
                                <span class="minute">{{ dataElectronicLecture.minuteExcercise }}</span>&nbsp;<span
                                    class="unit">phút</span>
                            </div>
                        </div>
                        <div class="display-flex">
                            <div>
                                <label>Số câu hỏi:</label>
                            </div>
                            &nbsp;&nbsp;
                            <div>
                                {{ dataElectronicLecture.countQuestion }}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">

                </div>
                <div class="wrap-btn-start-excercise col-md-5">
                    <a href="javascript:;"
                        class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                        @click="handleStartExcersice">

                        {{ this.dataCheckUserWork == 0 ? 'Bắt đầu làm bài' : 'Tiếp tục làm bài' }}
                    </a>
                    <div v-if="dataElectronicLecture.typeExcercise == 1" class="text-warning-excercise">
                        Bộ đếm thời gian không dừng và sẽ tự nộp bài nếu hết giờ
                    </div>
                </div>
            </div>

            <!-- <ModalSubmitExcercise @closeModal="isOpenModalSubmitExcercise = false" v-if="isOpenModalSubmitExcercise" /> -->
            <!-- <ModalTimeOutExcercise @closeModal="isOpenModalTimeOutExcercise = false" v-if="isOpenModalTimeOutExcercise" /> -->
            <!-- <ModalSuccessExcercise @closeModal="isOpenModalSuccessExcercise = false" v-if="isOpenModalSuccessExcercise" /> -->
        </div>

    </section>
</template>
<script>
import { getDetail } from './../../_api/LessonClassSchoolServices';
import { saveUserExcerciseClassSchool, checkUserHasWorkExcercise } from './../../_api/userExcerciseClassSchool';
export default {
    data() {
        return {
            lessonClassSchoolId: 0,
            classSchoolId: 0,
            dataElectronicLecture: {},
            dataCheckUserWork: 0
        }
    },
    mounted() {

        this.lessonClassSchoolId = this.$route.query.id
        this.classSchoolId = this.$route.query.classSchoolId
        this.getDetailLessonClassSchool()
        this.checkUserHasWork()
    },
    methods: {
        checkUserHasWork() {
            let params = {
                lessonClassSchoolId: this.lessonClassSchoolId,
                classSchoolId: this.classSchoolId
            }
            checkUserHasWorkExcercise(params).then((res) => {
                if (res && res.data && !res.errors) {
                    this.dataCheckUserWork = res.data
                    if (res.data == 2) {
                        this.$router.push({
                            path: "/lam-de-kiem-tra/bat-dau-lam-bai",
                            query: { id: this.lessonClassSchoolId, classSchoolId: this.classSchoolId, className: this.$route.query.className }
                        });
                    }
                }

            })
        },
        getDetailLessonClassSchool() {
            let self = this
            getDetail(this.lessonClassSchoolId).then(res => {
                if (res && res.data && !res.errors) {
                    self.dataElectronicLecture = res.data
                    console.log(this.dataElectronicLecture)
                }
            })
        },
        handleStartExcersice() {
            this.saveUserExcercise()

        },
        saveUserExcercise() {
            let params = {
                statusId: 1,
                lessonClassSchoolId: this.lessonClassSchoolId,
                classSchoolId: this.classSchoolId,

            }
            saveUserExcerciseClassSchool(params).then(() => {
                window.open('/lam-de-kiem-tra/bat-dau-lam-bai?id=' + this.dataElectronicLecture.id + '&classSchoolId=' + this.classSchoolId + '&className=' + this.$route.query.className, '_blank');
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.text-warning-excercise {
    color: #f97a7c;
}

.wrap-btn-start-excercise {
    text-align: center;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
}

.minute {
    font-size: 20px;
    color: #f97a7c;
}

.unit {
    color: #f97a7c;
}

.margin-top-20 {
    margin-top: 20px;
}

.margin-left-30 {
    margin-left: 30px;
}

.align-items-baseline {
    align-items: baseline;
}
</style>